/**
 * Store-purchase policy (src/platform/).
 *
 * Stripe plan, credit and course purchases are web-only: the native apps
 * never offer them, and never link out to a place to buy.
 */

import { isNativePlatform } from './detection'

/** True when Stripe purchase UI may be shown (plain web only). */
export function canShowStorePurchases(): boolean {
  return !isNativePlatform()
}
